
import { BuyerInventoryActivitySearchCriteria } from "./BuyerInventoryActivitySearchCriteria";

export interface BuyerInventoryAuditSearchCriteria {
  supplierId?: string;
  supplierName?: string;
  startDate?: string;
  endDate?: string;
  locationId?: string;
  bookingNumber?: string;
  orderNumber?: string;
  equipmentNumber?: string;
  equipmentType?: string;
  driverName?: string;
  driverNameExact?: boolean;
}

export const fromBuyerInventoryActivitySearchCriteria = (criteria: BuyerInventoryActivitySearchCriteria): BuyerInventoryAuditSearchCriteria => {
    return {
        supplierId: criteria.supplierId,
        supplierName: criteria.supplierName,
        startDate: criteria.startDate,
        endDate: criteria.endDate,
        locationId: criteria.locationId,
        bookingNumber: criteria.bookingNumber,
        orderNumber: criteria.orderNumber,
        equipmentNumber: criteria.equipmentNumber,
        equipmentType: criteria.equipmentType,
        driverName: criteria.driverName,
        driverNameExact: criteria.driverNameExact
    };
};